import { z } from "zod";

/**
 * Public Supabase environment.
 *
 * These values are inlined into the client bundle by Next.js (because of the
 * `NEXT_PUBLIC_` prefix), so they're safe to expose. The shape is identical
 * between hosted Supabase and a self-hosted stack — only the URL and the key
 * differ. Application code reads from `publicEnv`, never directly from
 * `process.env`, so a future hosted → self-hosted migration is config-only.
 */
const PublicEnvSchema = z.object({
  NEXT_PUBLIC_SUPABASE_URL: z.string().url(),
  NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
});

const parsed = PublicEnvSchema.safeParse({
  NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY:
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
});

if (!parsed.success) {
  const issues = parsed.error.issues
    .map((i) => `${i.path.join(".")}: ${i.message}`)
    .join("; ");
  throw new Error(
    `Public Supabase env is missing or invalid. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY in .env.local, then restart the dev server. Details: ${issues}`,
  );
}

export const publicEnv = parsed.data;
